// Son aktiviteler widget'ı — Blazor RecentActivityWidget (`api/data/GetRecentLogs/{userName}/{roleId}/{count}`).
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { apiClient } from '@/shared/api/http/client';
import { useAuthStore } from '@/entities/session/model/authStore';
import { formatLogDate, type SystemLogDto } from '@/features/auditlog/logsApi';
import { cn } from '@/shared/lib/cn';
import { EmptyState } from '@/shared/ui/EmptyState';
import { Spinner } from '@/shared/ui/Spinner';

const TONE: Record<string, string> = { insert: 'bg-success/15 text-success', update: 'bg-info/15 text-info', delete: 'bg-danger/15 text-danger', action: 'bg-warning/15 text-warning' };

export function RecentActivityWidget() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const q = useQuery({
    queryKey: ['home', 'recentLogs', user?.userName, user?.roleId],
    queryFn: () => apiClient.get<SystemLogDto[]>(`/api/data/GetRecentLogs/${encodeURIComponent(user!.userName ?? '')}/${user!.roleId}/20`, { octo: { expectSuccess: false } }),
    enabled: !!user?.roleId && !!user?.userName,
    staleTime: 60_000,
  });
  if (q.isLoading) return <div className="flex h-full items-center justify-center"><Spinner /></div>;
  const logs = q.data ?? [];
  if (!logs.length) return <EmptyState title={t('logs.empty')} />;
  return (
    <ul className="h-full space-y-1 overflow-auto text-sm">
      {logs.map((log) => {
        const type = (log.logType?.logTypeName ?? '').toLowerCase();
        return (
          <li key={log.logId} className="flex items-center gap-2">
            <span className={cn('shrink-0 rounded-full px-1.5 py-0.5 text-[10px] font-medium', TONE[type] ?? 'bg-bg-muted text-fg-muted')}>{log.logType?.logTypeName ?? '?'}</span>
            <span className="truncate">{log.info || log.keyFieldValue || '—'}</span>
            <span className="text-fg-subtle ml-auto shrink-0 text-xs">{formatLogDate(log.date)}</span>
          </li>
        );
      })}
    </ul>
  );
}
